import { AxiosService } from 'services';

export function AuthServiceLogin(formData) {

  const loginData = {
    email: formData.email.value,
    password: formData.password.value,
  };

  return AxiosService().post('authentication/login', loginData)
    .then(function (response) {
      if(response.data.token) {

        localStorage.setItem('@token', response.data.token);
        localStorage.setItem('@sidebar', response.data.admin);
        localStorage.setItem('@userId', response.data.idUser);
        localStorage.setItem('@brand', response.data.idCurrentBrand);
      }
      return response;
    })
  }

  export function AuthServiceLogout() {
    localStorage.removeItem('@token');
    localStorage.removeItem('@userId');
    localStorage.removeItem('@brand');
    localStorage.removeItem('@sidebar');
    window.location.reload();
}
